// src/constants/api.js
//export const API_URL = 'http://localhost:3001';
//export const API_URL = "https://demobackend.kaafi.net";
//export const API_URL = 'https://tanaad_api.kaafi.net';
//export const API_URL = 'https://muraalapi.kaafi.net';

console.log('api url:', process.env.REACT_APP_API_URL);
export const API_URL = process.env.REACT_APP_API_URL; // Fallback to localhost if env variable is not set

export const TIMEOUT = 5000; // milliseconds

// API Endpoints
export const ENDPOINTS = {
  SYS: 'api/sys',
};
